import {
    GET_RENTALS,
    GET_RENTALS_SUCCESS,
    GET_RENTALS_FAILURE,
    GET_RENTAL_PROPERTIES,
    GET_RENTAL_PROPERTIES_SUCCESS,
    GET_RENTAL_PROPERTIES_FAILURE,
    SET_RENTAL_FILTERS,
    RESET_RENTAL_FILTERS
} from './types';

// managedPropertyIds: string[] | undefined — a rental manager scoped to specific
// properties only ever gets those back (applied in the saga, mirrors
// RentalService.getRentalsByOrgId's managed_property_ids restriction).
export const getRentals = (orgId, managedPropertyIds) => ({
    type: GET_RENTALS,
    payload: { orgId, managedPropertyIds }
});

export const getRentalsSuccess = rentals => ({
    type: GET_RENTALS_SUCCESS,
    payload: rentals
});

export const getRentalsFailure = error => ({
    type: GET_RENTALS_FAILURE,
    payload: error
});

// Vacant rental-type properties for the org, for the "Property address" filter dropdown.
// managedPropertyIds narrows to a scoped rental manager's assigned properties, mirrors
// RentalService.getRentalOrgProperties on the backend.
export const getRentalProperties = (orgId, managedPropertyIds) => ({
    type: GET_RENTAL_PROPERTIES,
    payload: { orgId, managedPropertyIds }
});

export const getRentalPropertiesSuccess = options => ({
    type: GET_RENTAL_PROPERTIES_SUCCESS,
    payload: options
});

export const getRentalPropertiesFailure = error => ({
    type: GET_RENTAL_PROPERTIES_FAILURE,
    payload: error
});

// Property/status/date filters (the RentalFilters Apply/Reset row) — plain, synchronous
// UI state, held in the reducer so the page component doesn't need any local useState.
export const setRentalFilters = filters => ({
    type: SET_RENTAL_FILTERS,
    payload: filters
});

export const resetRentalFilters = () => ({
    type: RESET_RENTAL_FILTERS
});
